import React, { useContext } from 'react';

export type ToastContextType = {
  error(message: string, lifetime?: number): void;
  warning(message: string, lifetime?: number): void;
  success(message: string, lifetime?: number): void;
  info(message: string, lifetime?: number): void;
  remove(id: string): void;
};

export const ToastContext = React.createContext<ToastContextType | undefined>(undefined);

export const useToast = () => useContext(ToastContext);
